<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <div class="demo-form-inline">
          <el-form-item label="选择门店">
            <el-select v-model="formInline.id" placeholder="请选择"
            @change="getList">
              <el-option
                  v-for="index in typeDate"
                  v-bind:key="index.id"
                  :label="index.name"
                  :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="bottom_center_TO">
          <div class="bottom_center_TO_s">
            <h3>优惠券列表</h3>
            <el-button
              type="primary"
              class="vubutton"
              :header-cell-style="
                () => 'text-align: center;background:#eef1f6;'
              "
              @click="onSubmit"
            >+新增</el-button>
          </div>
          <el-radio-group class="bottom_centers" v-model="radioStatus"  @change="statusChange" size="small" fill="#1890ff">
            <el-radio-button  label=''>全部</el-radio-button>
            <el-radio-button label="NOT_START">准备中</el-radio-button>
            <el-radio-button label="ENABLED" >进行中</el-radio-button>
            <el-radio-button label="DISABLED">已作废</el-radio-button>
            <el-radio-button label="END">已结束</el-radio-button>
            <el-radio-button label="OVERDUE" >已过期</el-radio-button>
          </el-radio-group>
        </div>
      </el-form>

      <el-dialog title="创建优惠券" :visible.sync="dialogCouponVisible" width="60%">
        <el-form :model="couponForm" :rules="couponRules" ref="couponForm" label-width="180px" style="width: 80%">
          <el-form-item label="优惠券名称"  prop="name">
            <el-input v-model="couponForm.name" style="width: 400px">
            </el-input>
          </el-form-item>
          <el-form-item label="优惠券描述">
            <el-input type="textarea" v-model="couponForm.desc" style="width: 400px">
            </el-input>
          </el-form-item>
          <el-form-item label="优惠券类型"  prop="type">
            <el-select v-model="couponForm.type" placeholder="请选择"  style="width: 400px">
              <el-option
                  v-for="item in couponOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发放数量"  prop="amount">
            <el-input v-model.number="couponForm.amount" style="width: 400px">
            </el-input>
          </el-form-item>
          <el-form-item label="满减起价或者是折扣起价"  prop="limit">
            <el-input v-model.number="couponForm.limit" style="width: 400px">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="满减减多少,折扣打几折"  prop="discount">
            <el-input v-model.number="couponForm.discount" style="width: 400px">
              <template slot="append">元/折</template>
            </el-input>
          </el-form-item>
          <el-form-item label="有效期">
            <el-date-picker
                v-model="couponForm.timeRange"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="请选择门店"  prop="shop_id" style="margin-right: 20px">
            <el-select
                multiple
                v-model="couponForm.shop_id"
                placeholder="请选择"
                style="width: 400px"
            >
              <el-option
                  v-for="index in typeDate"
                  v-bind:key="index.id"
                  :label="index.name"
                  :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogCouponVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmitCoupon">确 定</el-button>
        </div>
      </el-dialog>

      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.start_date }}至{{scope.row.end_date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="180">
          <template slot-scope="scope">
            <span>{{ transactionCouponType(scope.row.ctype) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投放总量" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.total_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="领取数量" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.issue_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="使用数量" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.used_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <span>{{ transStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
<!--            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
            <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" @click="handleDisable(scope.$index, scope.row)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          class="pagination"
          @current-change="pageSize"
          background
          layout="prev, pager, next"
          :total="tabPage.count"
          :page-size="page_size"
      ></el-pagination>

    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        id: '',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      couponForm: {
        desc: ''
      },
      couponOptions: [{
        value: 'CASH_BACK',
        label: '立减'
      }, {
        value: 'DISCOUNT',
        label: '打折'
      }, {
        value: 'REBATE',
        label: '满减'
      }],
      couponRules:{
        name: [
          {required: true, message: '请输入优惠券名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请输入优惠券类型', trigger: 'blur'},
        ],
        amount: [
          {required: true, message: '请输入发放数量', trigger: 'blur'},
          { type: 'number' , message: '发放数量需为数字'},
        ],
        shop_id: [
          {required: true, message: '请输入可用店铺', trigger: 'blur'},
        ]
      },
      tableData:[],
      radioStatus: '',
      typeDate: [],
      dialogCouponVisible: false,
      isEdit: false,
      page_size: 5,
      page_no: 1,
      tabPage: {
        count: 0,
      },
    };
  },
  mounted() {
    this.getType()
    //
  },
  methods: {
    pageSize(index) {
      this.page_no = index
      this.getCoupons('')
    },
    statusChange(){
      console.log(this.radioStatus)
      this.getCoupons(this.radioStatus)
    },
    getCoupons(status){
      const url = this.$userList.shop_coupon_list + this.formInline.id + '/' + this.page_size + '/'  + this.page_no +  `?status=` + status
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.shop_coupons
          this.tabPage.count = res.data.total
        } else {
          res.message && this.$alert(res.message)
        }
      })
    },
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.getCoupons('')
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    onSubmit() {
      this.dialogCouponVisible = true
      this.isEdit = false
    },
    onSubmitCoupon() {
      this.$refs['couponForm'].validate((valid) => {
            console.log(valid)
            if (valid) {
              const url = this.$userList.create_coupon
              let coupon_scopes = []
              for (let shop of this.couponForm.shop_id) {
                coupon_scopes.push({
                  shop_id: shop
                })
              }
              this.$http
                  .post(url, {
                    coupon: {
                      name: this.couponForm.name,
                      ctype: this.couponForm.type,
                      total_amount: this.couponForm.amount,
                      discount_price: parseInt(this.couponForm.discount * 100),
                      base_price_limit: parseInt(this.couponForm.limit * 100),
                      restriction: 'ONE_PERSON_ONE_TIME',
                      restriction_count: 1,
                      status: 'ENABLED',
                      start_date: moment(this.couponForm.timeRange[0]).format("YYYY-MM-DD hh:mm:ss"),
                      end_date: moment(this.couponForm.timeRange[1]).format("YYYY-MM-DD hh:mm:ss"),
                      send_for: 'Common',
                      desc: this.couponForm.desc
                    },
                    coupon_scopes: coupon_scopes

                  }).then((res) => {
                if (res.code === 200) {
                  this.dialogCouponVisible = false
                  this.$message({
                    type: 'info',
                    message: `优惠券发放成功! ` + res.message,
                  });
                } else {
                  this.$message({
                    type: 'error',
                    message: `发放优惠券失败! ` + res.message,
                  });
                }
              })
            } else {
              return false
            }
          }
      )
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.dialogCouponVisible = true
      this.isEdit = true

    },
    handleDisable(index, row) {
      this.$confirm(`确认废除此优惠券？`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(()=>{
        const url = this.$userList.discard_coupon
        this.$http.post(url + row.id).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'info',
              message: `废除优惠券成功! `,
            })
          } else {
            this.$message({
              type: 'error',
              message: `废除优惠券失败 ` + res.message,
            });
          }
        })
      })
    },
    handleDelete(index, row) {
      console.log(index, row)
      this.$confirm(`确认删除此优惠券？`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(()=> {
        const url = this.$userList.delete_coupon
        this.$http.delete(url + row.id).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'info',
              message: `删除优惠券成功! `,
            })
          } else {
            this.$message({
              type: 'error',
              message: `删除优惠券失败 ` + res.message,
            });
          }
        })
      })
    },
    transactionCouponType(type) {
      for (let item of this.couponOptions){
        if (type === item.value){
          return item.label
        }
      }
      return ''
    },
    transStatus(status){
      if ("ENABLED" === status){
        return "进行中"
      } else if ("NOT_START" === status){
        return "准备中"
      } else if ("DISABLED" === status) {
        return "已作废"
      } else if ("END" === status) {
        return "已结束"
      } else if ("OVERDUE" === status) {
        return "已过期"
      }
    }
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
  margin-left: 20px;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.bottom_center_TO {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
}
.bottom_center_TO_s {
  display: flex;
  justify-content: start;
  align-items: center;
}
.top_name {
  width: 100%;
  height: 109px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  box-sizing: border-box;
  padding: 20px 0;
}
.name_list {
  width: 200px;
  height: 100%;
  border-right: solid 1px rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: 20px;
}
.name_color {
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}
.bottom_centers {
  position: relative;
  right: 0;
}
</style>
